import axios from 'axios';
import Cookies from 'js-cookie';
import { getAuthHeader, getTimeZone } from './userInfo-actions';

const jwtCookie = Cookies.get(
  `${process.env.REACT_APP_API_COOKIE_CONSTANT}`
);

export const userDataBilling = async () => {
  let dataBilling = await axios.get(
    `${process.env.REACT_APP_API_PATH_TREASURY}/campus/payment/billing`,
    {
      params: {},
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (dataBilling.data.userBilling) {
    return dataBilling.data.userBilling;
  }
  return false;
};

export const cfdiBilling = async () => {
  let cfdi = await axios.get(
    `${process.env.REACT_APP_API_PATH_TREASURY}/usecfdi`,
    {
      params: {},
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (cfdi.data.lstCfdiUse) {
    return cfdi.data.lstCfdiUse;
  }
  return false;
};

export const getPayments = async () => {
  let payments = await axios.get(
    `${process.env.REACT_APP_API_PATH_TREASURY}/campus/payment/dashboard`,
    {
      params: { timezone: getTimeZone() },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (payments.data.lstPayments) {
    return payments.data.lstPayments;
  }
  return false;
};

export const productPayment = async idCharge => {
  let paymentDetails = await axios.get(
    `${process.env.REACT_APP_API_PATH_TREASURY}/campus/payment/details`,
    {
      params: { idCharge, timezone: getTimeZone() },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (paymentDetails.data.paymentDetails) {
    return paymentDetails.data.paymentDetails;
  }
  return false;
};

export const setUserBilling = async (
  cfdiUse,
  email,
  lada,
  phone,
  isAutomatic
) => {
  const userData = await axios.post(
    `${process.env.REACT_APP_API_PATH_TREASURY}/campus/payment/billing`,
    {
      cfdiUse,
      email,
      lada,
      phone,
      isAutomatic
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (userData.data.created) {
    return true;
  }
  return false;
};

export const uploadConstancy = async file => {
  let credentials = {};
  const key = await axios.get(
    `${process.env.REACT_APP_API_PATH_TREASURY}/billing/key`,
    {
      headers: getAuthHeader(jwtCookie),
      params: {
        contentType: 'application/pdf',
        extension: 'pdf'
      }
    }
  );
  if (key.data.credentials) {
    credentials = key.data.credentials;
    let formData = new FormData();
    formData.append('acl', credentials.acl);
    formData.append('Content-Type', credentials.contentType);
    formData.append('key', credentials.key);
    formData.append('policy', credentials.policy);
    formData.append('X-Amz-Algorithm', credentials.xAmzAlgorithm);
    formData.append('X-Amz-Credential', credentials.xAmzCredential);
    formData.append('X-Amz-Date', credentials.xAmzDate);
    formData.append('x-amz-signature', credentials.xAmzSignature);
    formData.append('file', file);

    let options = {
      headers: {
        'Content-Type': credentials.contentType,
        Accept: '*/*'
      }
    };
    const request = await axios.post(
      'https://mayahii-user-billing.s3.us-east-1.amazonaws.com/',
      formData,
      options
    );
    if (
      request &&
      (request.status === 200 || request.status === 204)
    ) {
      return true;
    }
    return false;
  }
};
